import { getPortalUrl } from './portal';

export type NavLeaf = { title: string; href: string };
export type NavGroup = { title: string; children: readonly NavLeaf[] };
export type MainNavItem = NavLeaf | NavGroup;

export function isNavGroup(item: MainNavItem): item is NavGroup {
  return 'children' in item;
}

export const navigationConfig = {
  mainNav: [
    { title: 'Hosting', href: '/hosting' },
    { title: 'Domains', href: '/domains' },
    // Website Design is the headline service product (R3,990 Studio Starter)
    // and earns its own top-level slot for discoverability.
    { title: 'Website Design', href: '/services/website-design' },
    // Care + Email Setup live on a single /services/care surface since
    // 2026-05-09 (see _bmad-output/MARKETING_CARE_EMAIL_MERGE_2026-05-08.md).
    // The previous dropdown collapsed into a flat link — both products are
    // visible on the page itself via twin pricing tiles.
    { title: 'Care', href: '/services/care' },
    // Fibre disabled 2026-05-08 — service is not yet active. Page file
    // (FibrePage.tsx) and ROUTES.fibre constant are preserved; uncomment
    // here, in routes.tsx, in Footer.tsx, and the footerNav services
    // entry below to re-enable when the service launches.
    // { title: 'Fibre', href: '/fibre' },
    { title: 'About', href: '/about' },
    { title: 'Contact', href: '/contact' },
  ] as readonly MainNavItem[],

  ctaButton: {
    text: 'Get Started',
    href: '/hosting',
  },

  loginButton: {
    text: 'Client Login',
    href: getPortalUrl('/sign-in'),
    external: true,
  },

  footerNav: {
    quickLinks: [
      { title: 'Hosting Plans', href: '/hosting' },
      { title: 'Why SightHost', href: '/why-sighthost' },
      { title: 'About Us', href: '/about' },
      { title: 'Support', href: '/support' },
    ],
    services: [
      { title: 'Web Hosting', href: '/hosting' },
      { title: 'Website Design', href: '/services/website-design' },
      { title: 'Domain Registration', href: '/domains' },
      // Care + Email Setup merged into one page 2026-05-09. Single footer
      // entry points at the unified /services/care landing surface.
      { title: 'Care & Email Setup', href: '/services/care' },
      // Fibre disabled 2026-05-08 — see mainNav comment.
      // { title: 'Fibre Internet', href: '/fibre' },
    ],
    legal: [
      { title: 'Terms of Service', href: '/terms' },
      { title: 'Privacy Policy', href: '/privacy' },
      { title: 'Acceptable Use Policy', href: '/aup' },
      { title: 'Service Level Agreement', href: '/sla' },
      { title: 'Refund Policy', href: '/refund' },
      { title: 'Cookie Policy', href: '/cookies' },
    ],
  },
} as const;

export type NavigationConfig = typeof navigationConfig;
